import { SerializedGame } from "../level";
import { compressString, decompressString } from "./compression";

const STORAGE_KEY = "tower3_gamestate";

export class GameStateStorage {
  private static isTestEnvironment(): boolean {
    return (
      typeof window !== "undefined" &&
      (window.location.href.includes("test") ||
        window.location.href.includes("playwright") ||
        process.env.NODE_ENV === "test")
    );
  }

  static async saveGameState(gameState: SerializedGame): Promise<void> {
    if (this.isTestEnvironment()) {
      return;
    }

    try {
      const jsonString = JSON.stringify(gameState);
      const compressed = await compressString(jsonString);
      localStorage.setItem(STORAGE_KEY, compressed);
    } catch (error) {
      console.warn("Failed to save game state to localStorage:", error);
    }
  }

  static async loadGameState(): Promise<SerializedGame | null> {
    if (this.isTestEnvironment()) {
      return null;
    }

    try {
      const compressed = localStorage.getItem(STORAGE_KEY);
      if (!compressed) return null;

      const decompressed = await decompressString(compressed);
      return JSON.parse(decompressed) as SerializedGame;
    } catch (error) {
      console.warn("Failed to load game state from localStorage:", error);
      // Clear corrupted data
      this.clearSavedState();
      return null;
    }
  }

  static clearSavedState(): void {
    if (this.isTestEnvironment()) {
      return;
    }

    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.warn("Failed to clear saved game state:", error);
    }
  }

  static hasSavedState(): boolean {
    if (this.isTestEnvironment()) {
      return false;
    }

    return localStorage.getItem(STORAGE_KEY) !== null;
  }

  static async promptLoadSavedState(turnCount: number): Promise<boolean> {
    if (this.isTestEnvironment()) {
      return false;
    }

    return new Promise((resolve) => {
      const message = `A saved game was found (Turn ${turnCount}). Would you like to continue from where you left off?`;

      const result = window.confirm(message);
      resolve(result);
    });
  }
}
